import React from "react";

import { useTranslation } from "react-i18next";

import { BetSlipBetType } from "@gp/slip";
import { useRootAppStore } from "@hooks";
import BetSlipStore from "@state/bet-slip/BetSlipStore";
import { MobilePlatform } from "@state/stores/types";
import classNames from "classnames";
import { observer } from "mobx-react";

export default observer(function BetSlipBetTypeSelector(props: {
	store: BetSlipStore;
}) {
	const { t } = useTranslation();

	const rootStore = useRootAppStore<MobilePlatform>();

	return (
		<ul className="tabs--slip">
			<li className="tabs--slip__item">
				<button
					onClick={() => {
						if (rootStore.waitingPeriodStore.timeLeft > 0) {
							rootStore.waitingPeriodStore.activatePopup();
						}

						props.store.changeBetSlipBetType(BetSlipBetType.Normal);
					}}
					className={classNames(
						"tabs--slip__link tabs--slip__link--normal",
						{
							"is-active":
								props.store.betSlipBetType ===
								BetSlipBetType.Normal,
						}
					)}
				>
					{t<string>("BET_SLIP.TITLE")}
				</button>
			</li>
			<li className="tabs--slip__item">
				<button
					onClick={(e) => {
						if (rootStore.waitingPeriodStore.timeLeft > 0) {
							rootStore.waitingPeriodStore.deactivatePopup();
						}

						props.store.changeBetSlipBetType(
							BetSlipBetType.OneClickBet
						);
					}}
					className={classNames(
						"tabs--slip__link tabs--slip__link--oneclick",
						{
							"is-active":
								props.store.betSlipBetType ===
								BetSlipBetType.OneClickBet,
						}
					)}
				>
					{t<string>("BET_SLIP.ONE_CLICK_BET.LABEL")}
				</button>
			</li>
		</ul>
	);
});
